export default defineNuxtRouteMiddleware(async (to) => {
  if (to.path === '/login') return

  // On the server side, check cookie directly from the request
  if (import.meta.server) {
    const cookie = useCookie('monitor_session')
    if (!cookie.value) {
      return navigateTo('/login')
    }
    return
  }

  // On the client side, call the check endpoint
  try {
    const { authenticated } = await $fetch<{ authenticated: boolean }>('/api/auth/check')
    if (!authenticated) {
      return navigateTo('/login')
    }
  }
  catch {
    return navigateTo('/login')
  }
})
